import { render, staticRenderFns } from "./PlacesListWithModal.vue?vue&type=template&id=234647a3"
import script from "./PlacesListWithModal.vue?vue&type=script&lang=ts"
export * from "./PlacesListWithModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports